/**
 * Deze component zorgt voor het genereren van ee form select
 * via de props wordt het volgende doorgegeven
 * name
 * id
 * className
 * style
 * ref
 * options
 * selected

 *
 * @history
 * 23 november 2022
 * Basis implementatie
 *
 */

import React from "react";


export class FormSelect extends React.Component
{
    constructor(props) {
        super(props);

        this.state = {value: this.props.selected};

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        this.setState({value: event.target.value});
    }

    render()
    {
        return (
            <select name={this.props.name}  className={this.props.className} style={this.props.style} ref={this.props.zref} value={this.state.value} onChange={this.handleChange}>
                {this.props.options.map( (option, option_index) =>
                    (
                        <option value={option.value}>{option.label}</option>
                    )
                )
                }
            </select>


        )

    }
}

FormSelect.defaultProps = {
    className:"",
    style: {},
    ref:null,
    selected:""
};
